import { ToggleButton, ToggleButtonGroup, useTheme } from '@mui/material'
import { Field, FieldProps } from 'formik'

import useStyles from './index.styles'

interface IProps {
  name: string // formik field name
  options: { value: string; label: string }[]
  width: string // width if chips should be fixed width
}

const FormikChipToggleButton = (props: IProps) => {
  const { name, options, width } = props
  const classes = useStyles
  const theme = useTheme()

  const handleChange = (newValue: string, setFieldValue: (field: string, value: unknown, shouldValidate?: boolean | undefined) => void) => {
    setFieldValue(name, newValue)
  }

  return (
    <Field name={name}>
      {({ field, form }: FieldProps) => {
        const { setFieldValue } = form
        return (
          <ToggleButtonGroup
            value={field.value}
            exclusive
            onChange={(_e, newValue) => (newValue ? handleChange(newValue, setFieldValue) : {})}
            sx={classes.toggleButtonGroup}
          >
            {options.map((option) => (
              <ToggleButton key={option.value} value={option.value} aria-label={option.label} sx={{ ...classes.toggleButton(theme), width }}>
                {option.label}
              </ToggleButton>
            ))}
          </ToggleButtonGroup>
        )
      }}
    </Field>
  )
}

export default FormikChipToggleButton
